import { Component, model, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputComponent, InputOptions } from '@shared/components';
import { InputModes, InputTypes } from '@core/enums';

@Component({
  selector: 'ncp-brand-name-search',
  imports: [
    InputComponent,
    ReactiveFormsModule,
  ],
  templateUrl: './brand-name-search.component.html',
  styleUrl: './brand-name-search.component.scss',
})
export class BrandNameSearchComponent implements OnInit {
  protected inputOptions = signal<InputOptions>({});
  protected data = model<any>();

  protected formGroup: FormGroup = new FormGroup({
    search: new FormControl<string>(''),
  });

  get search() {
    return this.formGroup.get('search') as FormControl;
  }

  ngOnInit() {
    this.inputOptions.set(
      new InputOptions({
        id: 'brandNameSearch',
        name: 'search',
        type: InputTypes.text,
        mode: InputModes.search,
        initialValue: '',
        formControl: this.search,
        onKeyUp: this.onKeyUp,
      })
    );
  }

  onKeyUp = (event: KeyboardEvent, value: string) => {
    const searchValue = (value || '').toLowerCase().trim();

    const dropDownData = JSON.parse(localStorage.getItem('dropDownData') || '{}');
    const originalData = dropDownData.brandNameProducts || [];

    const filteredData = !searchValue
      ? originalData
      : originalData.filter((row: any) => {
        const searchableText = [
          row.description,
          row.productName,
          row.atcdescription,
          row.activeSubstance,
          row.strength,
          row.atc,
        ]
          .filter(Boolean)
          .join(' ')
          .toLowerCase();

        return searchableText.includes(searchValue);
      });

    this.data().allData.set(filteredData);
  };
}
